import React, { useState } from 'react';
import { useAbility } from '@casl/react';
import BenefitReminder from '../../Benefit/BenefitReminder';
import { AbilityContext } from '../../../config/abilityContext';
import CardImage from '../../../components/Utils/Cards/CardImage';
import { SimpleCenteredModal } from '../../../components';

const BenefitCard = ({ benefits, rrhh, location, onDelete, showInfo, showEdit }) => {
  const ability = useAbility(AbilityContext);
  const canEditBenefit = ability.can('update', 'Benefit');
  const image = benefits.benefitsImage?.fileUrl || '';
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState(null);
  const [modalTitle, setModalTitle] = useState('');

  const handleReminder = () => {
    setModalTitle('Notificación de Beneficio');
    setModalBody(<BenefitReminder benefit={benefits} hideModal={() => setModalShow(false)} />);
    setModalShow(true);
  };

  return (
    <>
      <CardImage
        classNameDescription="b-description-dash"
        item={benefits}
        image={image}
        location={location}
        rrhh={rrhh}
        canEdit={canEditBenefit}
        showInfo={() => showInfo(benefits)}
        showEdit={() => showEdit(benefits)}
        resend={() => handleReminder()}
        onDelete={() => onDelete(benefits)}
      />
      <SimpleCenteredModal
        size="lg"
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default BenefitCard;
